import React from 'react';
import AppsLinkRating from '../SinglecareApps/AppsLinkRating';
import SocialApps from '../SocialApps';
import './index.scss';
import _ from 'lodash';
import { GTM_APP_DOWNLOAD_CTA_MOBILE_CLICK } from '../../constants/defaults';
import { useTranslation } from 'react-i18next';

const NewFooter = () => {
  const { t } = useTranslation();
  const sendGTMEvent = () => {
    _.triggerGTMVirtualPageViewEvent({
      event: GTM_APP_DOWNLOAD_CTA_MOBILE_CLICK,
      device_type: 'mobile',
      formId: 'mobile-app',
      clickText: 'Get the free app',
      location: 'body'
    });
  };
  return (
    <div className="newFooterContainer">
      <div className="appFooterWrapper">
        <div className="footerHeadWrap">
          <div>
            <h2 className="title">
              So... ready to save?
              <br /> Get the free SingleCare app
            </h2>
            <div className="featuresWrap">
              <p>Always free for consumers</p>
              <p>Quickly access discount cards</p>
              <p>Over a billion dollars saved</p>
            </div>
            <AppsLinkRating isFromFooter={true} />
            <div className="getAppWrapper mobile-only">
              <a
                href="https://singlecare.onelink.me/OxIQ/yqw2zm9f"
                className="getApp"
                onClick={() => sendGTMEvent()}
                target="_blank"
                rel="noreferrer"
                aria-label="SingleCare iOS App"
              >
                Get the free app
              </a>
              <div className="imageContainer">
                <img
                  src="/content/images/apps/pill-bottle.png"
                  height="120"
                  width="106"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="desktop-only rightWrapper">
            <h3 className="scanTitle">
              Scan with your camera phone <br className="desktop-only" /> to
              download the app
            </h3>
            <img
              src="/content/images/apps/QR-code.svg"
              height="120"
              width="120"
              alt=""
            />
            <p className="appLinkText">Text a link to download the app</p>
            <div className="desktop-only">
              <SocialApps
                isApps={true}
                isLandingPages={true}
                labelText={'Phone number'}
                type={'mobileApps'}
                focusClass="whiteFocus"
              />
            </div>
          </div>
        </div>
        <div className="partnersWrap mobile-only">
          <span className="partnerTitle">Our partners</span>
          <br />
          <a
            href="https://www.mhanational.org/about"
            target="_blank"
            rel="noreferrer"
            aria-label="Mental Health America"
          >
            <img
              src="/content/images/footer/logos-partner-mha.svg"
              height="24"
              width="78"
              alt={t('Mental Health America logo')}
            />
          </a>
          <a
            href="https://www.heart.org/en/about-us"
            target="_blank"
            rel="noreferrer"
            aria-label="American Heart Association"
          >
            <img
              src="/content/images/apps/heart.svg"
              height="26"
              width="76"
              alt=""
            />
          </a>
        </div>
      </div>
      <div className="appFooterWrapper centerSection">
        <div className="partnersDesktopWrap desktop-only">
          <div className="partnersWrap">
            <div className="leftWrap">
              <a
                href="https://safe.pharmacy/buy-safely/?url=www.singlecare.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Safe Pharmacy"
              >
                <img
                  src="/content/images/footer/safe-pharmacy-logo.jpg"
                  className="pharmacyIcon"
                  height="32"
                  width="107"
                  alt=""
                />
              </a>
              <img
                src="/content/images/footer/BBB-logo.jpg"
                height="32"
                width="84"
                alt=""
              />
            </div>
            <div className="rightWrap">
              <a
                href="https://www.mhanational.org/about"
                target="_blank"
                rel="noreferrer"
                aria-label="Mental Health America"
              >
                <img
                  src="/content/images/footer/logos-partner-mha.svg"
                  height="27"
                  width="84"
                  alt={t('Mental Health America logo')}
                />
              </a>
              <a
                href="https://www.heart.org/en/about-us"
                target="_blank"
                rel="noreferrer"
                aria-label="American Heart Association"
              >
                <img
                  src="/content/images/footer/logos-partner-heart.svg"
                  height="28"
                  width="81"
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
        <div className="footerBottom">
          <div className="logosWrap">
            <a
              href="https://www.singlecare.com/"
              aria-label="SingleCare homepage"
            >
              <img
                src="/content/images/header/single-care-logo1.svg"
                height="32"
                width="189"
                alt="SingleCare"
              />
            </a>
            <div className="socialIconWrap">
              <a
                href="https://www.facebook.com/SingleCare"
                target="_blank"
                rel="noreferrer"
                aria-label="SingleCare on Facebook"
              >
                <img
                  src="/content/images/apps/facebook.svg"
                  height="32"
                  width="32"
                  alt=""
                />
              </a>
              <a
                href="https://www.instagram.com/singlecare/?hl=en"
                target="_blank"
                rel="noreferrer"
                aria-label="Singlecare on Instagram"
              >
                <img
                  src="/content/images/apps/instagram.svg"
                  height="32"
                  width="32"
                  alt=""
                />
              </a>
              <a
                href="https://twitter.com/singlecare"
                target="_blank"
                rel="noreferrer"
                aria-label="SingleCare on Twitter"
              >
                <img
                  src="/content/images/apps/twitter.svg"
                  height="32"
                  width="32"
                  alt=""
                />
              </a>
              <a
                href="https://www.linkedin.com/company/singlecare/mycompany/"
                target="_blank"
                rel="noreferrer"
                aria-label="SingleCare on LinkedIn"
              >
                <img
                  src="/content/images/apps/linked-in.svg"
                  height="32"
                  width="32"
                  alt=""
                />
              </a>
              <a
                href="https://www.trustpilot.com/review/www.singlecare.com"
                target="_blank"
                rel="noreferrer"
                aria-label="SingleCare on TrustPilot"
              >
                <img
                  src="/content/images/apps/trust-pilot.svg"
                  height="32"
                  width="32"
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="footerDescription">
            <p>
              Prescription savings vary by prescription and by pharmacy, and may
              reach up to 80% off cash price.
            </p>
            <p>
              This is a prescription discount plan.{' '}
              <span> This is NOT insurance </span>
              nor a Medicare prescription drug plan. The range of prescription
              discounts provided under this discount plan will vary depending on
              the prescription and pharmacy where the prescription is purchased
              and can be up to 80% off the cash price. You are fully responsible
              for paying your prescriptions at the pharmacy at the time of
              service, but you will be entitled to receive a discount from the
              pharmacy in accordance with the specific pre-negotiated discounted
              rate schedule.
            </p>
            <p>
              Pharmacy names, logos, brands, and other trademarks are the
              property of their respective owners.
            </p>
            <p>
              Towers Administrators LLC (operating as 'SingleCare
              Administrators') is the authorized prescription discount plan
              organization with its administrative office located at 4510 Cox
              Road, Suite 111, Glen Allen, VA 23060. SingleCare Services LLC
              ('SingleCare') is the vendor of the prescription discount plan,
              including their&nbsp;
              <a
                href="https://www.singlecare.com/"
                target="_blank"
                rel="noreferrer"
              >
                website
              </a>
              .
            </p>
            <p>
              For additional information, including an up-to-date list of
              pharmacies, or assistance with any problems related to this
              prescription drug discount plan, please contact customer service
              toll free at 844-234-3057, 24 hours a day, 7 days a week (except
              major holidays).
            </p>
            <p className="lastRow">
              {`© ${new Date().getFullYear()} SingleCare Administrators All Rights Reserved`}
              .&nbsp;
              <a
                href="https://www.singlecare.com/terms-and-conditions"
                target="_blank"
                rel="noreferrer"
              >
                Terms &amp; Conditions
              </a>
            </p>
          </div>
          <div className="mobile-only">
            <a
              href="https://safe.pharmacy/buy-safely/?url=www.singlecare.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Safe Pharmacy"
            >
              <img
                src="/content/images/footer/safe-pharmacy-logo.jpg"
                className="pharmacyIcon"
                height="32"
                width="107"
                alt=""
              />
            </a>
            <img
              src="/content/images/footer/BBB-logo.jpg"
              height="32"
              width="84"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewFooter;
